import { BUILD_VERSION } from '../../../version';

import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  version = BUILD_VERSION;
  currentYear = new Date().getFullYear();
}
